import React, { useContext, useState, useEffect } from "react";
import { TextField } from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { UploadImg } from "../Common/Controls/Controls";
import { infoSource, requestAxios } from "../../util/util";
import AppContext from "../../Context/AppContext";
import "./MiPerfil.css";

const MiPerfil = () => {
  const { checkUserSession, changeLoading, updateGestorNombre } =
    useContext(AppContext);
  const infoUs = checkUserSession();
  const [files, setFiles] = useState([]);
  const [validated, setValidated] = useState(false);
  const [currentRow, setCurrentRow] = useState({
    GesRazonSocial: infoUs.GesRazonSocial,
  });

  useEffect(() => {
    loadinfo();
  }, []);
  async function loadinfo() {
    const currR = await infoSource.Gestores.GetCurrentInfoGestor(infoUs);
    if (currR.gestorImagen != null)
      setFiles([
        {
          base64: `data:image/png;base64,${currR.gestorImagen.Image}`,
          type: `type/${currR.gestorImagen.Extension}`,
        },
      ]);
  }
  function showfile(files) {
    setFiles(files);
  }
  function setDataRow(field, data) {
    let newRow = { ...currentRow };
    newRow[field] = data;
    setCurrentRow(newRow);
  }
  async function saveData() {
    const PostObj = {
      gestor: { ...currentRow },
      file: { Base64: files[0].base64, extension: files[0].type.split("/")[1] },
    };
    changeLoading(true);
    const { error, data } = await requestAxios({
      url: `Gestores/upCurrentGestor`,
      method: "put",
      token: infoUs.bearer_token,
      data: PostObj,
    });
    if (error === "") {
      changeLoading(false);
      const MySwal = withReactContent(Swal);
      await MySwal.fire({
        title: <strong>Hecho!</strong>,
        html: <i>Guardado con éxito!</i>,
        icon: "success",
      });
      updateGestorNombre(PostObj.gestor.GesRazonSocial);
      window.location.reload();
    } else {
      alert("Error, try again");
    }
    changeLoading(false);
  }

  return (
    <section className="MiPerfil__Container">
      <h1>Detalles del Perfil</h1>
      <div className="MiPerfilItem__Container">
        <div>
          <h1>Foto de Perfil</h1>
          <h6>Tamaño recomendado(300x300)</h6>
          <div className="text-center">
            {files.map((file, i) => {
              return (
                <div
                  key={i}
                  className="MiPerfilimg"
                  style={{ backgroundImage: `url(${file.base64})` }}
                />
              );
            })}
            <br />
          </div>
          <UploadImg
            files={files}
            setFiles={showfile}
            types={["png", "jpg", "jpeg"]}
          />
        </div>
        <div>
          <TextField
            id="outlined-basic"
            label="Nombre Completo"
            variant="outlined"
            className="txtDireccionCalle"
            value={currentRow["GesRazonSocial"]}
            onChange={(input) =>
              setDataRow("GesRazonSocial", input.target.value)
            }
          />
        </div>
      </div>
      <button className="miPerfil__btnGuardar" onClick={() => saveData()}>
        Guardar
      </button>
    </section>
  );
};

export default MiPerfil;
